$(document).ready(function() {
  $('.main_testimonial').slick({
    dots: false,
    infinite: true,
    speed: 300,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<span class="slide-arrow prev-arrow"><svg width="50" height="50" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M59.3037 42.9512L27.6525 42.9512" stroke="#424E5A"/><path d="M39.2334 29.255C38.4614 30.1723 30.9989 38.7324 26.8817 43.0125L39.2334 54.9355" stroke="#424E5A"/><circle cx="40.5" cy="40.5" r="40" transform="rotate(-180 40.5 40.5)" stroke="black"/></svg></span>',
    nextArrow: '<span class="slide-arrow next-arrow"><svg width="50" height="50" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.6963 40.336L53.3475 40.3359" stroke="#424E5A"/><path d="M41.7666 54.0321C42.5386 53.1148 50.0011 44.5547 54.1183 40.2746L41.7666 28.3516" stroke="#424E5A"/><circle cx="40.5" cy="40.5" r="40" stroke="black"/></svg></span>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          infinite: true,
          dots: true,
          arrows:false
        }
      }
    ]
  });
 $('.main_logo').slick({
      speed: 4000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
      pauseOnHover: true,
      draggable: false,
      easing: 'linear',
      swipeToSlide: true,
  });

  $('.collection_slider').slick({
    centerMode: true,
    centerPadding: '200px',
    slidesToShow: 4,
    prevArrow: '<span class="slide-arrow prev-arrow"><svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.6963 39.9844L53.3475 39.9844" stroke="#424E5A"></path><path d="M41.7666 53.6805C42.5386 52.7633 50.0011 44.2031 54.1183 39.9231L41.7666 28" stroke="#424E5A"></path><circle cx="40.5" cy="40.5" r="40" stroke="black"></circle></svg></span>',
    nextArrow: '<span class="slide-arrow next-arrow"><svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.6963 39.9844L53.3475 39.9844" stroke="#424E5A"></path><path d="M41.7666 53.6805C42.5386 52.7633 50.0011 44.2031 54.1183 39.9231L41.7666 28" stroke="#424E5A"></path><circle cx="40.5" cy="40.5" r="40" stroke="black"></circle></svg></span>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          arrows: false,
          dots: true,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          arrows: false,
          dots: true,
        }
      }
    ]
  });

  $('.collection_slider .next-arrow').click(function() {
    $('.collection_slider .prev-arrow svg').show();
  });
  
  $(document).on('click','.facet-filters__label',function() {
    $('.cust_sorting').slideToggle();
    $(this).toggleClass('active');
  });

  
  $(document).on('click','.single_acco .que',function() {
    $(this).parent('.single_acco').find('.ans').slideToggle();
    $(this).parent('.single_acco').toggleClass('active');
    $(this).parent('.single_acco').siblings('.single_acco').removeClass('active');
    $(this).parent('.single_acco').siblings().find('.ans').slideUp();
  });

  $('.post_type input').click(function() {
    var val = $(this).val();
    if (val == "post") {
      $('.post_text').slideDown();
    } else {
      $('.post_text').slideUp();
    }
  });

  $('.mobile_filter').click(function() {

    $(this).next('.facets').slideToggle();
    $(this).toggleClass('active')
    
  })

  $('.mega-menu .list-menu__item').click(function(){
    $('body').toggleClass('overflow')
  });


  $('.mega-menu .header__menu-item').click(function(){
    $(this).next('.mega-menu__content').fadeToggle();
    $(this).toggleClass('rotate')
  });
  
  
});
























